<div class="top-controls">
  <button
      (click)="onClose()"
      [disabled]="isLoading()"
      aria-label="Close slideshow"
      class="close-btn"
  >
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24">
      <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-linecap="round" stroke-width="2"/>
    </svg>
  </button>
  <div class="slide-counter">
    {{ currentIndex() + 1 }} / {{ totalSlides() }}
  </div>
</div>
